import { createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";
import { IndustriesTypes } from "./industry-actions";

export const INITIAL_STATE = Immutable({
    fetchingIndustries: false,
    creating: false,
    updating: false,

    industries: null,
    createdIndustry: null,
    updateIndustry: null,

    errorIndustries: null,
    errorCreating: null,
    errorUpdating: null,
})

export const industriesRequest = (state) => {
    return { ...state, fetchingIndustries: true, industries: null }
}

export const createRequest = (state) => {
    return { ...state, creating: true }
}

export const updateRequest = (state) => {
    return { ...state, updating: true }
}

export const industriesSuccess = (state, action) => {
    const { industries } = action;
    return { ...state, industries: industries, errorIndustries: null, fetchingIndustries: false }
}

export const createSuccess = (state, action) => {
    const { industry } = action;
    return { ...state, createdIndustry: industry, creating: false, errorCreating: null }
}

export const updateSuccess = (state, action) => {
    const { editedIndustry } = action;
    return { ...state, updateIndustry: editedIndustry, updating: false, errorUpdating: null }
}

export const industriesFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorIndustries: error, fetchingIndustries: false }
}

export const createFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorCreating: error, creating: false, createdIndustry: null }
}

export const updateFailure = (state, action) => {
    const { error } = action;
    return { ...state, errorUpdating: error, updating: false, updateIndustry: null }
}

export const reducer = createReducer(INITIAL_STATE, {
    [IndustriesTypes.INDUSTRIES_REQUEST]: industriesRequest,
    [IndustriesTypes.CREATE_INDUSTRY_REQUEST]: createRequest,
    [IndustriesTypes.UPDATE_INDUSTRY_REQUEST]: updateRequest,

    [IndustriesTypes.INDUSTRIES_SUCCESS]: industriesSuccess,
    [IndustriesTypes.CREATE_INDUSTRY_SUCCESS]: createSuccess,
    [IndustriesTypes.UPDATE_INDUSTRY_SUCCESS]: updateSuccess,

    [IndustriesTypes.INDUSTRIES_FAILURE]: industriesFailure,
    [IndustriesTypes.CREATE_INDUSTRY_FAILURE]: createFailure,
    [IndustriesTypes.UPDATE_INDUSTRY_FAILURE]: updateFailure,
})
